import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { UsersService } from '../service/users.service';
import { MasterService } from '../service/master.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Role } from '../app.constant';

@Component({
    selector: 'contract-company-app',
    templateUrl: './contract-company.component.html',
    styleUrls: ['contract-company.component.css']
})
export class ContractCompanyComponent implements OnInit {
    @Input() event_id: number;
    title : string = '契約会社マスタ';
    page : number = 1;
    isLoaded : boolean = false;
    selected : boolean = false;
    datalist : any = [];
    tempdatalist : any = [];
    editmode : boolean = false;

    constructor(
        private commonService: CommonService,
        private masterService: MasterService,
        public usersService: UsersService,
        private router: Router,
        private location: Location,
    ) { }
    
    ROLE: any = Role;

    ngOnInit(): void {
        this.getList();
    };
    clearData (): void{
        this.isLoaded = false;
        this.datalist = [];
    }

    getList(): void {
        this.clearData();
        this.masterService.getContractCompany(1)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.datalist= res["fuel_results"];
                for (let i = 0; i < this.datalist.length; i++) {
                    this.datalist[i]['password_change_flg'] = this.commonService.exchange01toTF(this.datalist[i]['password_change_flg']);
                    this.datalist[i]['password_complexity_flg'] = this.commonService.exchange01toTF(this.datalist[i]['password_complexity_flg']);
                    this.datalist[i]['monsin_contract_flg'] = this.commonService.exchange01toTF(this.datalist[i]['monsin_contract_flg']);
                    this.datalist[i]['yoyaku_contract_flg'] = this.commonService.exchange01toTF(this.datalist[i]['yoyaku_contract_flg']);
                    }
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    checkData(data:any):boolean{
        if (data.name == null || data.name == "" || data.name.length > 128 || 
            data.name_short == null || data.name_short == "" || data.name_short.length > 128 || 
            data.representative == null || data.representative == "" || data.representative.length > 64 || 
            data.tel == null || data.tel == "" || data.tel.length > 15 || 
            data.mail_from == null || data.mail_from == "" || data.mail_from.length > 64 ||
            data.mail2 == null || data.mail2 == "" || data.mail2.length > 128 || 
            data.zip == null || data.zip == "" || data.zip.length > 7 || 
            data.address1 == null || data.address1 == "" || data.address1.length > 128 ||
//            data.address2.length > 128 ||
//            data.address3.length > 128 ||
            data.password_lock_count == null || data.password_lock_count == "" || 
            data.password_expire_days == null || data.password_expire_days == "" 
        ){
            return false;
        }else{
            if( data.mail2.match(/^[\w\d_¥!#$%&'*+/=?^`{|}~\\-]+([.]?[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-])*[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]*@[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]+(?:\.[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]+)+$/) &&
                data.zip.match(/^[0-9]+$/) && 
                data.zip.length == 7 &&
                data.password_lock_count.match(/^[0-9]+$/) && 
                data.password_expire_days.match(/^[0-9]+$/)
            ){
                return true;
            }else{
                return false;
            }
        }
    }

    save(data:any): void {
        this.commonService.modalOpens(50001,
            //保存してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    data.password_change_flg = this.commonService.exchangeTFto01(data.password_change_flg);
                    data.password_complexity_flg = this.commonService.exchangeTFto01(data.password_complexity_flg);
                    data.monsin_contract_flg = this.commonService.exchangeTFto01(data.monsin_contract_flg);
                    data.yoyaku_contract_flg = this.commonService.exchangeTFto01(data.yoyaku_contract_flg);

                    data.mail2 = data.mail2.replace(/\s+/g, "");
                    this.masterService.saveContractCompany(data)
                    .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10001,modalresult=>{
                                    if (modalresult == "OK"){
                                        this.editmode = !this.editmode;
                                        this.getList();
                                     }
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                }else{
                    //
                }
            }
        );

        window.scrollTo(0, 0);
    }
    cancel():void{
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
                 modalresult => {
                    if (modalresult == "OK"){
                        this.editmode = false;
                        this.datalist= this.tempdatalist;
                    }else{
    
                    }
                }
            );
    }

    // 編集
    edit(mode:number): void {
        //退避
        this.tempdatalist = JSON.parse(JSON.stringify(this.datalist))
        this.editmode = !this.editmode;
        window.scrollTo(0, 0);
    }

    goBack(): void {
        if(this.editmode){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.location.back();
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.location.back();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/a0120-contract-company/contract-company.component.ts